import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@max/leez-image';
import Sensor from '@max/mbc-sensor';
import LinearGradient from '@hfe/max-linear-gradient';
import { PlayAttributeType } from '../../types/api';
import './index.scss';
const DEFAULT_BG_IMAGE_LIST = ['https://p0.meituan.net/ingee/948f265c35e403118f4bfe8e63e2ac407673.png', 'https://p0.meituan.net/ingee/ef2944c061201e79914fb82ebd5cd48c7252.png', 'https://p0.meituan.net/ingee/4fba8d19683ff54d48d405dd0b8c8c867438.png'];
function ExperienceCard({ item, index, onAppear, bgImageList }) {
    // 从 playAttributes 中提取体验亮点和实用Tips
    const highlights = item.playAttributes.find(attr => attr.type === PlayAttributeType.EXPERIENCE_HIGHLIGHT)?.content || item.desc || '';
    const tips = item.playAttributes.find(attr => attr.type === PlayAttributeType.USEFUL_TIPS)?.content || '';
    // 从 playAttributes 中提取驾车时间
    const drivingInfo = item.playAttributes.find(attr => attr.type === PlayAttributeType.TRAFFIC_DISTANCE_DESC);
    const coverImageUrl = item.images?.[0]?.url || '';
    const resolvedBgImageList = bgImageList && bgImageList.length > 0 ? bgImageList : DEFAULT_BG_IMAGE_LIST;
    const bgImageUrl = resolvedBgImageList[index % resolvedBgImageList.length];
    return <Sensor once onAppear={onAppear}>
      <Image source={{
        uri: bgImageUrl
    }} style={{
        width: '618rpx',
        height: '296rpx',
        marginRight: '12rpx'
    }}>
        <View className="experience-card">
          <View className="experience-card__cover">
            <Image source={{
        uri: coverImageUrl
    }} className="experience-card__cover-image" style={{
        width: '212rpx',
        height: '282rpx'
    }} widthHeightRatio={212 / 282} resizeMode='cover'>
              <LinearGradient colors={['#00000000', '#000000ff']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} className="experience-card__info-wrap">
                <View className="experience-card__info">
                  <Text className="experience-card__title" numberOfLines={1}>{item.playName}</Text>

                  {drivingInfo && <View className="experience-card__driving-tag">
                      <Image source={{
        uri: 'https://p0.meituan.net/ingee/842d0272785f1a14ba44bc25456f661d587.png'
    }} className="experience-card__driving-icon" style={{
        width: '24rpx',
        height: '24rpx'
    }}></Image>
                      <Text className="experience-card__driving-text">{drivingInfo.content}</Text>
                    </View>}
                </View>
              </LinearGradient>
            </Image>
          </View>

          <View className="experience-card__content">
            <View className="experience-card__highlights">
              <Image source={{
        uri: 'https://p0.meituan.net/ingee/db647706e6aabbda29e5fcb2a59fb67d1259.png'
    }} className="experience-card__icon" style={{
        width: '28rpx',
        height: '28rpx'
    }}/>
              <Text className="experience-card__highlights-text" numberOfLines={3}>
                <Text className="experience-card__label">体验亮点：</Text>
                <Text className="experience-card__highlights-content" numberOfLines={3}>{highlights}</Text>
              </Text>
            </View>

            {tips && <View className="experience-card__tips">
                <Image source={{
        uri: 'https://p0.meituan.net/ingee/b50cbef480915ed863c15746ab9e184c1160.png'
    }} className="experience-card__icon" style={{
        width: '28rpx',
        height: '28rpx'
    }}/>
                <Text className="experience-card__tips-text" numberOfLines={3}>
                  <Text className="experience-card__label">实用Tips：</Text>
                  {tips}
                </Text>
              </View>}
          </View>
        </View>
      </Image>
    </Sensor>;
}
export default memo(ExperienceCard);
